import { ReactNode, forwardRef, ForwardedRef } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

type Props = React.HtmlHTMLAttributes<HTMLAnchorElement | HTMLDivElement> & {
    children: ReactNode;
    className?: string;
    variant?: 'primary' | 'secondary';
    to?: string;
    style?: React.CSSProperties;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    tabIndex?: number;
};

const Card = forwardRef<HTMLDivElement | HTMLAnchorElement, Props>(
    (
        {
            children,
            className = '',
            variant = 'primary',
            to,
            style,
            onClick,
            tabIndex,
            ...rest
        },
        ref
    ) => {
        const cardClassName = clsx(`card card-${variant}`, className);

        return to ? (
            <Link
                to={to}
                className={cardClassName}
                style={style}
                ref={ref as ForwardedRef<HTMLAnchorElement>}
                tabIndex={tabIndex}
                {...rest}
            >
                {children}
            </Link>
        ) : (
            <div
                className={clsx(cardClassName, { 'card-clickable': !!onClick })}
                onClick={onClick}
                style={style}
                ref={ref as ForwardedRef<HTMLDivElement>}
                tabIndex={tabIndex}
                {...rest}
            >
                {children}
            </div>
        );
    }
);

export default Card;
